<script>
import options from './DitRaaderumCalculator.options'

export default options
</script>

<template>
    <NykBanner
        v-if="errorMessage && !isErrorDismissed"
        class="nyk-dit-raaderum-calculator__error-banner"
        :message="errorMessage"
        background-color="var(--nds-color-brand-secondary)"
        :dismissible="true"
        :dismiss-label="labels.dismissError"
        role="alert"
        @dismiss="dismissError" />

    <section class="nyk-dit-raaderum-calculator" aria-live="polite">
        <DitRaaderumCalculatorInputCard
            :labels="labels"
            :legal-labels="legalLabels"
            :number-input-format="numberInputFormat"
            :house-value="initialHouseValue"
            :remaining-debt="initialRemainingDebt"
            :is-loading="isLoading"
            @update-house-value="updateHouseValue"
            @update-remaining-debt="updateRemainingDebt"
            @calculate="calculate" />
        <DitRaaderumCalculatorResultCard
            :labels="labels"
            :result="result"
            :format-amount="formatAmount" />

        <LegalText :jura-modal="legalLabels" />
    </section>
</template>